var DOCUMENT_IMAGE_MIN_RESOLUTION = { width: 400, height: 300 };
var DOCUMENT_IMAGE_BLUR_THRESHOLD = 70;
var IMAGE_QUALITY_PARAMS = {
    front: {
        blurThreshold: DOCUMENT_IMAGE_BLUR_THRESHOLD,
        brightnessThreshold: 50,
        contrastThreshold: 35,
        darknessThreshold: 30,
        darkPixelRatioLimit: 0.5,
        minResolution: DOCUMENT_IMAGE_MIN_RESOLUTION,
    },
    back: {
        blurThreshold: DOCUMENT_IMAGE_BLUR_THRESHOLD,
        brightnessThreshold: 190,
        contrastThreshold: 29,
        darknessThreshold: 50,
        darkPixelRatioLimit: 0.6,
        minResolution: DOCUMENT_IMAGE_MIN_RESOLUTION,
    }
};
function meetsMinimumResolution(width, height, minWidth, minHeight) {
    var imageShortSide = Math.min(width, height);
    var imageLongSide = Math.max(width, height);
    var minimumShortSide = Math.min(minWidth, minHeight);
    var minimumLongSide = Math.max(minWidth, minHeight);
    return imageShortSide >= minimumShortSide && imageLongSide >= minimumLongSide;
}
function checkImageResolution(image, minWidth, minHeight) {
    return meetsMinimumResolution(image.naturalWidth, image.naturalHeight, minWidth, minHeight);
}
;
function isImageBlurry(imageData, isFront) {
    var width = imageData.width;
    var height = imageData.height;
    var data = imageData.data;
    var grayscale = new Float32Array(width * height);
    for (var i = 0; i < width * height; i++) {
        var offset = i * 4;
        var r = data[offset];
        var g = data[offset + 1];
        var b = data[offset + 2];
        grayscale[i] = 0.299 * r + 0.587 * g + 0.114 * b;
    }
    var kernel = [-1, -1, -1,
        -1, 8, -1,
        -1, -1, -1];
    var laplacianValues = [];
    for (var y = 1; y < height - 1; y++) {
        for (var x = 1; x < width - 1; x++) {
            var sum = 0;
            for (var ky = -1; ky <= 1; ky++) {
                for (var kx = -1; kx <= 1; kx++) {
                    var pixelVal = grayscale[(y + ky) * width + (x + kx)];
                    var kernelVal = kernel[(ky + 1) * 3 + (kx + 1)];
                    sum += pixelVal * kernelVal;
                }
            }
            laplacianValues.push(sum);
        }
    }
    var mean = laplacianValues.reduce(function (acc, val) { return acc + val; }, 0) / laplacianValues.length;
    var variance = laplacianValues.reduce(function (acc, val) { return acc + Math.pow(val - mean, 2); }, 0) / laplacianValues.length;
    var threshold = isFront ? IMAGE_QUALITY_PARAMS.front.blurThreshold : IMAGE_QUALITY_PARAMS.back.blurThreshold;
    var isBlurry = variance < threshold;
    if (isBlurry) {
        console.log("Image is blurry: variance = ".concat(variance, ", threshold = ").concat(threshold));
    }
    return isBlurry;
}
;
function checkBrightnessAndContrast(imageData, isFront) {
    var brightnessThreshold = isFront ? IMAGE_QUALITY_PARAMS.front.brightnessThreshold : IMAGE_QUALITY_PARAMS.back.brightnessThreshold;
    var contrastThreshold = isFront ? IMAGE_QUALITY_PARAMS.front.contrastThreshold : IMAGE_QUALITY_PARAMS.back.contrastThreshold;
    var sumBrightness = 0;
    var sumContrast = 0;
    for (var i = 0; i < imageData.data.length; i += 4) {
        var r = imageData.data[i];
        var g = imageData.data[i + 1];
        var b = imageData.data[i + 2];
        var brightness = (r + g + b) / 3;
        sumBrightness += brightness;
    }
    var avgBrightness = sumBrightness / (imageData.data.length / 4);
    for (var i = 0; i < imageData.data.length; i += 4) {
        var r = imageData.data[i];
        var g = imageData.data[i + 1];
        var b = imageData.data[i + 2];
        var brightness = (r + g + b) / 3;
        sumContrast += Math.abs(brightness - avgBrightness);
    }
    var avgContrast = sumContrast / (imageData.data.length / 4);
    var passesBrightnessContrast = avgBrightness > brightnessThreshold && avgContrast > contrastThreshold;
    if (!passesBrightnessContrast) {
        console.log("Brightness/Contrast check failed: avgBrightness = ".concat(avgBrightness, ", brightnessThreshold = ").concat(brightnessThreshold, ", avgContrast = ").concat(avgContrast, ", contrastThreshold = ").concat(contrastThreshold));
    }
    return passesBrightnessContrast;
}
;
function isImageTooDark(imageData, isFront) {
    var darknessThreshold = isFront ? IMAGE_QUALITY_PARAMS.front.darknessThreshold : IMAGE_QUALITY_PARAMS.back.darknessThreshold;
    var darkPixelRatioLimit = isFront ? IMAGE_QUALITY_PARAMS.front.darkPixelRatioLimit : IMAGE_QUALITY_PARAMS.back.darkPixelRatioLimit;
    var darkPixels = 0;
    for (var i = 0; i < imageData.data.length; i += 4) {
        var brightness = (imageData.data[i] + imageData.data[i + 1] + imageData.data[i + 2]) / 3;
        if (brightness < darknessThreshold) {
            darkPixels++;
        }
    }
    var darkPixelRatio = darkPixels / (imageData.data.length / 4);
    var isTooDark = darkPixelRatio > darkPixelRatioLimit;
    if (isTooDark) {
        console.log("Image is too dark: darkPixelRatio = ".concat(darkPixelRatio, ", darkPixelRatioLimit = ").concat(darkPixelRatioLimit));
    }
    return isTooDark;
}
;
function checkImageQuality(image, isFront) {
    if (isFront === void 0) { isFront = false; }
    var minResolution = isFront ? IMAGE_QUALITY_PARAMS.front.minResolution : IMAGE_QUALITY_PARAMS.back.minResolution;
    return checkImageResolution(image, minResolution.width, minResolution.height);
}
;
function isResolutionTooLow(width, height, isFront) {
    var minResolution = isFront ? IMAGE_QUALITY_PARAMS.front.minResolution : IMAGE_QUALITY_PARAMS.back.minResolution;
    return !meetsMinimumResolution(width, height, minResolution.width, minResolution.height);
}
;
function resizeImage(base64Str, maxWidth, maxHeight, options) {
    return new Promise(function (resolve) {
        var img = new Image();
        img.src = base64Str;
        img.onload = function () {
            var _a;
            var canvas = document.createElement('canvas');
            var MAX_WIDTH = maxWidth;
            var MAX_HEIGHT = maxHeight;
            var width = img.width;
            var height = img.height;
            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            }
            else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.drawImage(img, 0, 0, width, height);
            }
            var outputType = (_a = options === null || options === void 0 ? void 0 : options.mimeType) !== null && _a !== void 0 ? _a : 'image/png';
            resolve(canvas.toDataURL(outputType, options === null || options === void 0 ? void 0 : options.quality));
        };
    });
}
;
function rotateImage(imageElement, degrees) {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var radians = degrees * (Math.PI / 180);
    var width = imageElement.naturalWidth;
    var height = imageElement.naturalHeight;
    // Ajusta dimensões do canvas para 90 ou 270 graus
    if (degrees % 180 === 0) {
        canvas.width = width;
        canvas.height = height;
    }
    else {
        canvas.width = height;
        canvas.height = width;
    }
    // Move origem para o centro do canvas antes de rotacionar
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(radians);
    // Desenha a imagem com compensação para o centro rotacionado
    ctx.drawImage(imageElement, -width / 2, -height / 2);
    var rotatedImg = new Image();
    rotatedImg.src = canvas.toDataURL("image/png");
    return rotatedImg;
}
var ImageUtils = {
    checkImageResolution: checkImageResolution,
    isImageBlurry: isImageBlurry,
    checkBrightnessAndContrast: checkBrightnessAndContrast,
    isImageTooDark: isImageTooDark,
    checkImageQuality: checkImageQuality,
    isResolutionTooLow: isResolutionTooLow,
    resizeImage: resizeImage,
    rotateImage: rotateImage
};
export default ImageUtils;
